import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import axios from "axios";
import { parseAxiosError } from "../../utils/AxiosUtils";
import { loadUser } from "../../utils/AuthDataUtils";
import { isEmployee, isManager, isSeller } from "../../utils/AuthoritiesUtils";
import {
  datetimeStringToStringAgo,
  formatPhoneString,
  inlineReturn,
  labelOptions,
  optionValueToLabel,
} from "../../utils/StringUtils";

import { Col, Input, Row, Button } from "reactstrap";

import CustomAlert from "../../components/CustomAlert";
import CustomTable from "../../components/CustomTable";
import CustomPagination from "../../components/CustomPagination";

export default function Users() {
  const user = loadUser();
  console.log("Render Users, user:", user !== null);

  const navigate = useNavigate();

  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [searchLock, setSearchLock] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [message, setMessage] = useState("");

  const error = (message) => {
    setMessage(message);
  };

  const fetchData = useCallback(() => {
    const url = "user/all?page=0&key=" + search;
    setLoading(true);
    axios
      .get(url)
      .then((res) => {
        setTotalPages(res.data.totalPages);
        setPage(0);
        setSearchLock(search);
        setUsers(res.data.content);
      })
      .catch((err) => error(parseAxiosError(err)))
      .finally(() => setLoading(false));
  }, [search]);

  useEffect(() => fetchData(), [fetchData]);

  const onPageChange = (number) => {
    console.log("Orders onPageChange", number);
    let params = ["page=" + number];
    if (searchLock && searchLock.length) {
      params.push("key=" + searchLock);
    }
    setPage(number);
    setLoading(true);
    axios
      .get("user/all?" + params.join("&"))
      .then((res) => {
        setUsers(res.data.content);
      })
      .catch((err) => error(parseAxiosError(err)))
      .finally(() => setLoading(false));
  };

  const onNew = () => {
    console.log("Users onNew");
    navigate("/user-new");
  };

  const onRowClick = (index) => {
    console.log("Users onRowClick", index);
    navigate("/user-details", { state: { phone: users[index].phone } });
  };

  const employeeString = (user) => {
    if (isEmployee(user)) return "Pracownik";
    return "Klient";
  };

  const labelString = (user) => {
    if (isEmployee(user)) return "";
    return optionValueToLabel(labelOptions(), user.label);
  };

  const tableLayout = [
    { name: "Imię i nazwisko", key: (u) => inlineReturn(u.name) },
    { name: "Typ klienta", key: (u) => labelString(u) },
    { name: "Rola", key: (u) => employeeString(u) },
    { name: "Telefon", key: (u) => formatPhoneString(u.phone) },
    { name: "Utworzony", key: (u) => datetimeStringToStringAgo(u.createdAt) },
  ];

  const AddButton = () => {
    if (!isManager(user) && !isSeller(user)) {
      return;
    }
    return (
      <Col xs="auto">
        <Button color="secondary" onClick={onNew}>
          Dodaj nowego
        </Button>
      </Col>
    );
  };

  return (
    <Col sm={{ size: 10, offset: 1 }} md={{ size: 10, offset: 1 }}>
      <Row className="mt-lg-3">
        <CustomAlert
          message={message}
          color="danger"
          dismiss={() => setMessage("")}
        />
        <Row className="mt-lg-3">
          <Col>
            <Input
              type="text"
              placeholder={"Fragment nr tel. albo imienia i nazwiska"}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
          <AddButton />
        </Row>
        <Row className="mt-lg-3">
          <CustomTable
            loading={loading}
            data={users}
            layout={tableLayout}
            onRowClick={onRowClick}
          />
        </Row>
        <Row>
          <CustomPagination
            visible={!loading && users.length}
            current={page}
            total={totalPages}
            onChange={onPageChange}
          />
        </Row>
      </Row>
    </Col>
  );
}
